import { Component } from '@angular/core';

import '../../prism/prism.js';
import { LanguageSettings } from '../../providers/languageSettings.service';

declare var Prism;

@Component({
  selector: 'app-example-advanced-module',
  templateUrl: './example-advanced-module.html',
  styleUrls: ['../bleclassmodule/bleclassmodule.css']
})
/**
 * lol messiest class ever
 */
export class ExampleAdvancedComponent {

/**
 * SG REGISTER LOGGER CONTENT
 */
JavaRegisterLoggerPrism: string;
JavaRegisterLogger =
"SGConnect.registerLogger(new SGLoggerDelegate(){ \n\
  @Override \n\
  public void log(SGLogLevel level, String msg, String TAG) { \n\
      Log.i(TAG,\"onUpdateLog: importance:\"+ level + \" msg: \" + msg); \n\
  } \n\
});";

SwiftRegisterLoggerPrism: string;
SwiftRegisterLogger =
"class ViewController: UIViewController { \n\
  override func viewDidLoad() { \n\
    super.viewDidLoad() \n\
    //register logger and set log level to info  \n\
    SGConnect.registerLogger(self) \n\
  } \n\
} \n\
//extension conforming ViewController to SGLoggerDelegate protocol\n\
extension ViewController : SGLoggerDelegate { \n\
  //MARK: SGLoggerDelegate methods \n\
  func log(message: String, atLevel level: SGLogLevel, fromFunction caller: String) { \n\
      print(\" \\(level): from \\(caller) - \\(message)\") \n\
  } \n\
} \n\
";

JavaScriptRegisterLoggerPrism: string;
JavaScriptRegisterLogger =
'SGConnectAPIPlugin.registerLogger((log) => this.handleLog(log));\n\
\n\
private handleLog(log) {\n\
  //log is a json string and with keys = message, level & fromFunction with values as strings\n\
  const logObj = JSON.parse(log);\n\
  console.log(logObj.level + \':\' + logObj.message);\n\
}';
/**
 * Set Log level
 */
JavaSetLogLevelPrism:string;
JavaSetLogLevel:string = "\
SGConnect.setLogLevel(SGLogLevel.DEBUG);";

SwiftSetLogLevelPrism:string;
SwiftSetLogLevel:string = "\n\
SGConnect.setLogLevel(at: .DEBUG);\n\
";

JavaScriptSetLogLevelPrism:string;
JavaScriptSetLogLevel:string = "\n\
SGConnectAPIPlugin.setLogLevel('DEBUG');\n\
";


/**
 * Set RSSI levels
 */
JavaSetConnectionRangePrism: string;
JavaSetConnectionRange = "\n SGConnectBLE.setConnectionRange(50, 90); \n ";

SwiftSetConnectionRangePrism: string;
SwiftSetConnectionRange = "\n SGConnectBLE.SetConnectionRange(connectRSSI: 50, disconnectRSSI: 90) \n";

JavaScriptSetConnectionRangePrism: string;
JavaScriptSetConnectionRange = "\n SGConnectAPIPlugin.setConnectionRange(50, 90); \n";

/**
 * SGFeature
 */
JavaSGFeaturePrism: string;
JavaSGFeature =
'SGConnectBLE.enable(new SGFeature(SGFeature.SECURITY)); \n\
SGConnectBLE.disable(new SGFeature(SGFeature.SECURITY)); \n\
';

SwiftSGFeaturePrism: string;
SwiftSGFeature =
'SGConnectBLE.enable(feature: .security)\n\
SGConnectBLE.disable(feature: .security)\n\
';

JavaScriptSGFeaturePrism: string;
JavaScriptSGFeature =
'SGConnectAPIPlugin.enableEncryption();\n\
SGConnectAPIPlugin.disableEncryption();\n\
';

    constructor(public languageSettings: LanguageSettings) {
      this.applyPrism();
    }

    applyPrism() {
        this.JavaRegisterLoggerPrism = Prism.highlight(this.JavaRegisterLogger, Prism.languages.java);
        this.SwiftRegisterLoggerPrism = Prism.highlight(this.SwiftRegisterLogger, Prism.languages.swift);
        this.JavaScriptRegisterLoggerPrism = Prism.highlight(this.JavaScriptRegisterLogger, Prism.languages.javascript);

        this.JavaSetLogLevelPrism = Prism.highlight(this.JavaSetLogLevel, Prism.languages.java);
        this.SwiftSetLogLevelPrism = Prism.highlight(this.SwiftSetLogLevel, Prism.languages.swift);
        this.JavaScriptSetLogLevelPrism = Prism.highlight(this.JavaScriptSetLogLevel, Prism.languages.javascript);

        this.JavaSetConnectionRangePrism = Prism.highlight(this.JavaSetConnectionRange, Prism.languages.java);
        this.SwiftSetConnectionRangePrism = Prism.highlight(this.SwiftSetConnectionRange, Prism.languages.swift);
        this.JavaScriptSetConnectionRangePrism = Prism.highlight(this.JavaScriptSetConnectionRange, Prism.languages.javascript);

        this.JavaSGFeaturePrism =  Prism.highlight(this.JavaSGFeature, Prism.languages.java);
        this.SwiftSGFeaturePrism = Prism.highlight(this.SwiftSGFeature, Prism.languages.swift);
        this.JavaScriptSGFeaturePrism = Prism.highlight(this.JavaScriptSGFeature, Prism.languages.javascript);

    }
}